/**
 * Chunk Error Handler
 * Detecta quando um chunk dinamicamente importado não consegue ser carregado
 * (comum após novo deploy enquanto user está na app)
 *
 * Recarrega a página automaticamente de forma silenciosa.
 */

let hasReloadedDueToChunkError = false;

export function initChunkErrorHandler(): void {
  // Detecta erros de chunk faltante via error event
  window.addEventListener('error', (event) => {
    if (isChunkLoadError(event.error)) {
      handleChunkErrorSilently();
      event.preventDefault();
    }
  });

  // Detecta erros de chunk faltante via unhandledrejection
  window.addEventListener('unhandledrejection', (event) => {
    if (isChunkLoadError(event.reason)) {
      handleChunkErrorSilently();
      event.preventDefault();
    }
  });
}

function isChunkLoadError(error: unknown): boolean {
  if (!error) return false;

  if (error instanceof Error) {
    const message = error.message.toLowerCase();
    return (
      message.includes('failed to fetch dynamically imported module') ||
      message.includes('failed to fetch') ||
      (message.includes('chunk') && message.includes('failed')) ||
      message.includes('loading chunk')
    );
  }

  return false;
}

function handleChunkErrorSilently(): void {
  // Evita loop infinito de recarregar
  if (hasReloadedDueToChunkError) {
    return;
  }

  hasReloadedDueToChunkError = true;

  // Aguarda um pouco para o usuário não ver piscada de erro
  // e para evitar conflito com outros tratadores
  setTimeout(() => {
    // Recarrega silenciosamente
    window.location.reload();
  }, 1000);
}

